var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-customer-previewPc"},[_c('component-download',{attrs:{"menuInfo":_vm.menuInfo,"units":_vm.units,"pre":_vm.pre}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }